import { useTranslation } from "react-i18next";
import { VoucherCard } from "dds4/components/VoucherCard/v1/VoucherCard";

const WIDTH = 360;
const HEIGHT = 210;
const STUB_WIDTH = 80;
const NOTCH_RADIUS = 12;
const NOTCHES = [
  { position: { x: WIDTH - STUB_WIDTH, y: 0 }, radius: NOTCH_RADIUS },
  { position: { x: WIDTH - STUB_WIDTH, y: HEIGHT+STUB_WIDTH }, radius: NOTCH_RADIUS },
];

export default function Discounts() {
  const { t } = useTranslation();
  return (
    <div className="flex drop-shadow-lg" aria-hidden={true}>
      <VoucherCard
        fillColor="var(--color-background-primary)"
        borderStyle="none"
        borderRadius={25}
        notches={NOTCHES}
        style={{ width: WIDTH, height: HEIGHT }}
      >
        <div className="flex font-poppins text-white" style={{ height: HEIGHT }}>
          <div className="flex flex-1 flex-col justify-center gap-2 px-6">
            <span className="text-xs font-semibold uppercase tracking-widest">{t("Landing.decor.discounts.label")}</span>
            <div className="flex items-baseline gap-2">
              <span className="text-4xl font-bold">30%</span>
              <span className="text-xl font-bold uppercase">{t("Landing.decor.discounts.off")}</span>
            </div>
            <span className="text-base">{t("Landing.decor.discounts.partners")}</span>
            <div className="mt-2 w-fit rounded-xl border-2 border-dashed border-white px-4 py-2 text-base font-semibold uppercase tracking-widest">
              {t("Landing.decor.discounts.save", { value: "30%" })}
            </div>
          </div>
          <div className="flex shrink-0 items-center justify-center" style={{ width: STUB_WIDTH }}>
            <span className="-rotate-90 whitespace-nowrap text-lg font-bold uppercase tracking-widest">{t("Landing.decor.points", { value: "3,000" })}</span>
          </div>
        </div>
      </VoucherCard>
    </div>
  );
}
